import { Divider, IconButton, Paper, Typography } from "@mui/material";

import { Box } from "@mui/system";
import React from "react";
import { MdArrowBackIosNew } from "react-icons/md";
import { useNavigate } from "react-router";
import { DateConverter } from "../../reusable-component/DateConverter";
import GreenChip from "../chips/GreenChip";
import RedChip from "../chips/RedChip";
import YellowChip from "../chips/YellowChip";
import UtcMinusFour from "../../utils/UtcMinusFour";

const formatCreationDate = (dateString) => {
  const date = new Date(dateString);
  const utcMinusFour = new UtcMinusFour(date);
  return utcMinusFour.formatUtcMinusFour("yyyy-MM-dd hh:mm a");
};

const WorkflowHeaderData = ({ data }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box style={{ width: "35px" }}>
        <IconButton
          size="small"
          aria-label="delete"
          onClick={() => navigate(-1)}
        >
          <MdArrowBackIosNew />
        </IconButton>
      </Box>
      <Paper
        sx={{ width: "100%", display: "flex", justifyContent: "space-around" }}
      >
        <Box style={{ display: "flex", justifyContent: "space-evenly" }}>
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="overline"
              sx={{ color: "#8798AD", fontWeight: "bold" }}
            >
              WORKFLOW
            </Typography>
            <Typography variant="h5" gutterBottom sx={{ color: "#00043C" }}>
              {data.firstHeaderText}
            </Typography>
          </Box>
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box style={{ display: "flex", justifyContent: "space-evenly" }}>
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="overline"
              sx={{ color: "#8798AD", fontWeight: "bold" }}
            >
              FUNCTION
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ color: "#00043C" }}>
              {data.secondHeaderText}
            </Typography>
          </Box>
        </Box>

        <Box style={{ display: "flex", justifyContent: "space-evenly" }}>
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="overline"
              sx={{ color: "#8798AD", fontWeight: "bold" }}
            >
              SUB-FUNCTION
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ color: "#00043C" }}>
              {data.thirdHeaderText}
            </Typography>
          </Box>
        </Box>

        <Box style={{ display: "flex", justifyContent: "space-evenly" }}>
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="overline"
              sx={{ color: "#8798AD", fontWeight: "bold" }}
            >
              PIPELINE
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ color: "#00043C" }}>
              {data.fourthHeaderText}
            </Typography>
          </Box>
        </Box>
        <Box style={{ display: "flex", justifyContent: "space-evenly" }}>
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="overline"
              sx={{ color: "#8798AD", fontWeight: "bold" }}
            >
              CREATED BY
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ color: "#00043C" }}>
              {data.fifthHeaderText}
            </Typography>
          </Box>
        </Box>
        <Box style={{ display: "flex", justifyContent: "space-evenly" }}>
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="overline"
              sx={{ color: "#8798AD", fontWeight: "bold" }}
            >
              CREATED ON
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ color: "#00043C" }}>
              {formatCreationDate(data.sixthHeaderText)}
            </Typography>
          </Box>
        </Box>

        <Box style={{ display: "flex", justifyContent: "space-evenly" }}>
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="overline"
              sx={{ color: "#8798AD", fontWeight: "bold" }}
            >
              STATUS
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ color: "#00043C" }}>
              {data.seventhHeaderText === "approved" ? (
                <GreenChip title="Approved" />
              ) : data.seventhHeaderText === "pending" ? (
                <YellowChip title="Pending" />
              ) : (
                <RedChip title="Rejected" />
              )}
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default WorkflowHeaderData;
